import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { FixedAsset } from '../../../../core/models/fixedasset.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from '../../../../core/services/loading/loading';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { FixedassetService } from '../../../../core/services/fixedasset/fixedasset-service';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { FixedassetForm } from '../fixedasset-form/fixedasset-form';
import { TermPipe } from '../../../../shared/pipes/term.pipe';
import { TermKey } from '../../../../core/models/terminology.interface';

@Component({
  selector: 'app-fixedasset-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
    TermPipe,
  ],
  templateUrl: './fixedasset-list.html',
  styleUrl: './fixedasset-list.scss',
})
export class FixedassetList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  termKey = TermKey;
  fixedAssets: FixedAsset[] = [];
  asyncFixedassets!: Observable<FixedAsset[]>;
  buscarfixedassets: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = ['acciones', 'id', 'name', 'description', 'lifetime', 'term'];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private fixedAssetService: FixedassetService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Activos Fijos');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchFixedAsset(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchFixedAsset(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncFixedassets = this.fixedAssetService.getFixedAsset(params).pipe(
      tap((data) => {
        this.fixedAssets = data.results;
        this.fixedAssetService.setFixedAsset(data.results[0]);
        this.fixedAssetService.setFixedAssets(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createFixedAsset() {
    this.fixedAssetService.removeFixedAssetSelected();
    const dialogRef = this.dialog.open(FixedassetForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchFixedAsset(this.page);
    });
  }

  updateFixedAsset(fixedAsset: FixedAsset) {
    this.fixedAssetService.setFixedAsset(fixedAsset);
    const dialogRef = this.dialog.open(FixedassetForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchFixedAsset(this.page);
    });
  }

  eliminate(fixedAsset: FixedAsset): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el registro: ${fixedAsset.name}?`);
    if (!confirmed) return;
    this.fixedAssetService.delete(fixedAsset.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchFixedAsset(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
